<template>
  <Modal v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">转入物品</div>
    <Form :model="formData" :label-width="80" :rules="formRules" ref="transferFormData" >
      <FormItem label="物品编码" prop="goodsArchivesCode" >
        <Input v-model="formData.goodsArchivesCode" class="item-width" ></Input>
      </FormItem>
      <FormItem label="转入项目" prop="projectId">
          <Select v-model="formData.projectId" @on-change="changeProject" class="item-width">
              <Option value=''>请选择</Option>
              <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </FormItem>
      <FormItem label="转入区域" prop="configArea">
          <Select class="item-width" v-model="formData.configArea"  @on-change="setConfigAreaFid">
              <Option value=''>请选择</Option>
              <Option v-for="item in configArea" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </FormItem>
      <FormItem :label="formData.configArea==='' ? '' : (formData.configArea===2?'功能区':'房间号')" prop="configAreaFid">
        <Select  class="item-width" v-if="formData.configArea===2" key="functionalArea" v-model="formData.configAreaFid" filterable placeholder="请选择" >
            <Option value="">{{ formData.projectId==='' ? '请先选择项目': (fnAreaList.length === 0?'暂无数据':'请选择')}}</Option>
            <Option v-for="item in fnAreaList" :value="item.value" :key="item.value">{{ item.text }}</Option>
        </Select>  
        <Select
          class="item-width"
          key="room"
          v-if="formData.configArea===1"
          v-model="formData.configAreaFid"
          filterable
          remote
          :remote-method="remoteMethod"
          :loading="loading"
          :placeholder="formData.projectId==='' ?'请先选择项目':'请输入想查询的房间号'">
          <Option v-for="item in roomList" :value="item.value" :key="item.value">{{item.text}}</Option>
        </Select>
    </FormItem>
    </Form>
    <div slot="footer">
        <Button type="text" size="large" @click="handleCancel">取消</Button>
        <Button type="primary" size="large" @click="transferIn" :loading="loading">
          <span v-if="!loading">转入</span>
          <span v-else>转入中...</span>
        </Button>
      </div>
  </Modal>
</template>
<script type="text/ecmascript-6">

import { getSelectedData,transferGoodsIn } from 'api/archives'
import { checkCode } from 'api/archives.js'
import { getFnByProject,getBuildInfo,fuzzyRoom } from 'api/functionalArea'
export default {
  props: {
    n: {
      type: Number,
      default: 0
    }
  },
  created(){
    this.initData()
  },
  data() {
    const validateArchivesCode = (require,value,callback) => {
      if(value===''){
        callback(new Error('输入物品编码'))
      } else {
        checkCode({'goodsArchivesCode':value}).then(res=>{
          if(!res.data) {
            callback(new Error('物品编码不存在'))
          } else {
            callback()
          }
        })
      }  
    }
    const validateConfigAreaFid = (require,value,callback) => {
      if(this.formData.configArea===1 && value===''){
        callback(new Error('请输入房间号'))
      } else if (this.formData.configArea===2 && value==='') {
        callback(new Error('请选择功能区'))
      }   
      callback() 
    }
    return {
      show: false,
      loading: false,
      formData:{
        goodsArchivesCode:'',
        projectId:'',
        configArea:'',
        configAreaFid:''
      },
      projectList:[],
      configArea:[],
      fnAreaList:[],
      roomList:[],
      formRules:{
        goodsArchivesCode:[{ required: true,validator:validateArchivesCode,  trigger:'blur'}],
        projectId:[{ required: true, message:'请选择转入的项目',trigger:'change'}],
        configArea: [{required: true, message:'请选择配置区域',type:'number',trigger:'change'}],
        configAreaFid: [{required: true, validator:validateConfigAreaFid,type:'string',trigger:'change'}]
      }
    };
  },
  watch: {
    n(val) {
      this.$refs['transferFormData'].resetFields();
      this.formData.goodsArchivesCode=''
      this.formData.projectId=''
      this.formData.configArea=''
      this.formData.configAreaFid=''
      this.loading = false
      this.show = true;
    }
  },
  methods: {
    initData(){
      getSelectedData().then(res => {
        this.configArea = res.data.configArea
        getBuildInfo().then( res => {
          this.projectList = res.data
        })
      })
    },
    setConfigAreaFid(){
      this.formData.configAreaFid = ''
      this.roomList = []
    },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    changeProject(value) {
      if(value !== ''){
        this.formData.configArea = ''
        this.formData.configAreaFid = ''
        getFnByProject({projectid:value}).then( res => {
          if(res.data.length === 0) {
            this.fnAreaList = []
          } else{
            this.fnAreaList = res.data
          } 
        })
      }else{
        this.formData.configArea = ''

      }
     
    },
    remoteMethod(query){
      if (query !== '' && this.formData.projectId !=='') {
        this.loading = true;
        let params = {
          projectid:this.formData.projectId,
          roomnumber:query
        }
        fuzzyRoom(params).then( res => {
          this.loading = false;
          this.roomList = res.data;
        })
      } else {
          this.roomList = [];
          this.formData.configAreaFid=''
      }
    },
    handleCancel(){
      this.show = false
    },
    transferIn() {
      let data = null
      this.$refs["transferFormData"].validate(bool => {
        if (bool) {  
          data = this.formData;
          transferGoodsIn(data).then( res=> {
            this.$Message.success('转入成功');
            this.changeLoading()
            this.$emit('refresh')
            this.show=false
          }).catch( () => {
            this.changeLoading()
          })
        } 
      });
    }
  }
};
</script>
 
<style lang="css" scoped>
.item-width{
    width: 260px;
}
.area-width{
    width: 324px;
}
 .wd80{
   width: 70px;
 }
  .wd216{
   width: 186px;
 }
</style>